import BaseNode from './BaseNode'

export default {
  components: {
    BaseNode
  },
  inject: ['$t'],
  props: {
    doc: {
      type: Object,
      required: true
    },
    node: {
      type: Object,
      required: true
    },
    parent: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    editorErrors: {
      type: Array,
      required: true
    }
  },
  computed: {
    account() {
      return this.$store.state.account
    }
  }
}
